import React from "react";
import { Card, Placeholder } from "react-bootstrap";

const StatsCardSkeletonComponent: React.FC = () => {
    return (
        <div className="mb-4">
            <Card>
                <Card.Header>
                    <Card.Title>
                        <Placeholder as="span" animation="glow">
                            <Placeholder xs={8} />
                        </Placeholder>
                    </Card.Title>
                </Card.Header>
                <Card.Body>
                    <h1>
                        <Placeholder as="span" animation="glow">
                            <Placeholder xs={4} />
                        </Placeholder>
                    </h1>
                    <p>
                        <Placeholder as="span" animation="glow">
                            <Placeholder xs={6} />
                        </Placeholder>
                    </p>
                </Card.Body>
            </Card>
        </div>
    );
};

export default StatsCardSkeletonComponent;
